export { default } from './sign-in-widget-container';
